export const DATABASE_KEY_LOCALE = 'SasDBLocale';
export const DATABASE_KEY = 'SasDB';
export const DATABASE_CACHE_KEY = 'SasDbCache';
